// src/Firebase.js

import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, collection, addDoc,getDocs,  onSnapshot, query, where } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// ✅ Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAqEH52VhBnomxzNHmPQpyAPXZc2NWpeAg",
  authDomain: "products-5dbf3.firebaseapp.com",
  projectId: "products-5dbf3",
  storageBucket: "products-5dbf3.appspot.com",
  messagingSenderId: "767900403853",
  appId: "1:767900403853:web:29fc4c0639ca397c44fac4",
  measurementId: "G-XJV83PGDJ3"
};

// ✅ Initialize Firebase app
const app = initializeApp(firebaseConfig);

// ✅ Export Firebase services
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const messaging = getMessaging(app);


export { db, storage, auth, provider, createUserWithEmailAndPassword, addDoc,getDocs, collection, onSnapshot, uploadBytesResumable, query, where, getDownloadURL, messaging };
